import { Service } from "@roc/feature-app-core";

export const url = {
  GET_TOKEN: '/api/v1/utility/twilio/token/getToken',
};

export class TwilioService extends Service {

  getToken(identity: string) {
    return this.get(url.GET_TOKEN, { identity }, { responseType: 'text', disableGlobalLoading: true });
  }
}
